/**
 * Money formatting — web-billing.
 *
 * Money is stored and transported as integer cents server-side (invoices.ts /
 * billable_events.billable_amount). Never ACCUMULATE, compare or round dollars in
 * floating point — do the arithmetic in integer cents and convert once, at the
 * point of display, which is all this module does.
 *
 * ALL money DISPLAYED IN THE UI MUST go through formatUsdFromCents. There is
 * exactly one deliberate exception in this package: lib/aging-csv.ts renders
 * `(cents / 100).toFixed(2)` because a spreadsheet column must be a bare decimal
 * with no currency symbol or thousands separator. If you add another money
 * surface and it is not a machine-readable export, it belongs here.
 */

/** Format integer cents as USD. Money is integer cents server-side (invoices.ts). */
export function formatUsdFromCents(cents: number): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
}
